window.TRACE = function (msg, level) {
    if (KS.isDebug) {
        KS.log(msg, level);
    }
}